import { useEffect, useMemo, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { LangContext } from "@/context";
import { translations } from "@/i18n";
import { setLenis } from "@/lib/scroll";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";

function App() {
    const [lang, setLangState] = useState(() => localStorage.getItem("bs-lang") || "en");
    const t = useMemo(() => translations[lang] || translations.en, [lang]);

    const setLang = (l) => {
        setLangState(l);
        localStorage.setItem("bs-lang", l);
    };

    useEffect(() => {
        document.title = t.meta.title;
        document.documentElement.lang = lang;
    }, [lang, t]);

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09 });
        setLenis(lenis);
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            setLenis(null);
        };
    }, []);

    return (
        <LangContext.Provider value={{ lang, setLang, t }}>
            <div className="App">
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-center" richColors />
            </div>
        </LangContext.Provider>
    );
}

export default App;
